module.exports = __webpack_public_path__ + "static/media/format_italic.112c475d.svg";